import { render, staticRenderFns } from "./CategoryImport2.vue?vue&type=template&id=56763cac&scoped=true&"
import script from "./CategoryImport2.vue?vue&type=script&lang=js&"
export * from "./CategoryImport2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56763cac",
  null
  
)

export default component.exports